import { theme } from '../../theme';
import Header from '../Header';
import LinearProgress from '@material-ui/core/LinearProgress';
import React, { Fragment } from 'react';
import { Container, MuiThemeProvider } from '@material-ui/core';
import { Helmet } from 'react-helmet'

const DefaultLayout = (props) => {
  const { isLoading, title } = props
  return <MuiThemeProvider theme={theme}>
    <>
      <Helmet>
        <title>{title ? `${title}` : ''}</title>
      </Helmet>
      <Fragment>
        <LinearProgress
          style={{ visibility: isLoading ? "visible" : "hidden" }}
        />
        <Container style={{ marginTop: 30 }}>
          {props.children}
        </Container>
      </Fragment>
    </>
  </MuiThemeProvider>
}

export default DefaultLayout
